import { clearLastVisitedDashboardRoute } from "replo-utils/lib/lastVisitedDashboardIds";
import {
  getReploRootCookieDomain,
  REPLO_ACCOUNT_HINT_COOKIE,
} from "schemas/cookies";

const clearAccountHintCookie = () => {
  // Expire both the apex-scoped (production) and host-only (localhost) variants.
  const apexDomain = getReploRootCookieDomain(window.location.hostname);
  if (apexDomain) {
    document.cookie = `${REPLO_ACCOUNT_HINT_COOKIE}=; domain=${apexDomain}; path=/; max-age=0`;
  }
  document.cookie = `${REPLO_ACCOUNT_HINT_COOKIE}=; path=/; max-age=0`;
};

export const storeToken = (token: string | null) => {
  clearLastVisitedDashboardRoute();
  if (!token) {
    localStorage.removeItem("andytown__token2");
    clearAccountHintCookie();
  } else {
    localStorage.setItem("andytown__token2", token);
  }
};
